/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HchbDocumentType = {
    Other: 'other',
} as const;
export type HchbDocumentType = typeof HchbDocumentType[keyof typeof HchbDocumentType];


export function instanceOfHchbDocumentType(value: any): boolean {
    for (const key in HchbDocumentType) {
        if (Object.prototype.hasOwnProperty.call(HchbDocumentType, key)) {
            if (HchbDocumentType[key as keyof typeof HchbDocumentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HchbDocumentTypeFromJSON(json: any): HchbDocumentType {
    return HchbDocumentTypeFromJSONTyped(json, false);
}

export function HchbDocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbDocumentType {
    return json as HchbDocumentType;
}

export function HchbDocumentTypeToJSON(value?: HchbDocumentType | null): any {
    return value as any;
}

export function HchbDocumentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): HchbDocumentType {
    return value as HchbDocumentType;
}

